import React from 'react'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@material-ui/core/index'
import { strings } from '../../../../localization/strings'
import Loader from '../../../loaders/dots_loader/index'
import {
    getOrderAddress,
    updateOrderAddress,
} from '../../../../helpers/restHelpers'
import TextField from '@material-ui/core/TextField/TextField'
import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox/Checkbox'
import { notAlowedCharactersRegExp } from '../../../../utils/regex'
import { ReplaceQuotes } from '../../../../utils/formaters'

const initialState = {
    open: false,
    loading: false,
    wasEdited: false,
    streetName: '',
    streetNumber: '',
    floor: '',
    apartment: '',
    locality: '',
    errors: {},
    // helperText: {},
    city: '',
    streetNumberEmpty: false,
}
class Component extends React.Component {
    state = { ...initialState }

    componentDidMount() {}

    handleClickOpen = () => {
        this.setState({ open: true, loading: true })
        getOrderAddress(this.props.orderId)
            .then((x) => {
                this.setState({ loading: false, ...x })
            })
            .catch((error) => {
                this.handleClose(true)
                window.showDialog(error)
            })
    }

    handleClose = (force) => {
        if (force !== true) {
            if (this.state.loading) return
        }
        this.setState({ ...initialState })
    }

    confirmValidate = () => {
        // let errors = {}
        // let helperText = {}
        let errors = { ...this.state.errors }
        errors.streetName = !this.state.streetName.trim()
        errors.streetNumber = !this.state.streetNumber.trim()
        this.setState({ errors })
        
        // Caracteres especiales
        // let { streetName, streetNumber, floor, apartment, locality, city } = this.state
        // let fieldsToValidate = {streetName, streetNumber, floor, apartment, locality, city}
        // errors.streetName = !streetName.trim()
        // errors.streetNumber = !streetNumber.trim()
        // for (let field in fieldsToValidate) {
        //     if (notAlowedCharactersRegExp.test(fieldsToValidate[field])) {
        //         errors[field] = true;
        //         helperText[field] = strings.notAllowedCharacters
        //     }
        // }
        // this.setState({ errors, helperText })

        return !Object.values(errors).some((x) => x === true)
    }

    confirm = () => {
        if (!this.confirmValidate()) {
            return
        }

        this.handleClose(true)
        this.setState({ loading: true })
        const { orderId } = this.props
        const { streetName, streetNumber, floor, apartment, locality, city } =
            this.state
        const data = {
            orderId,
            streetName,
            streetNumber,
            floor,
            apartment,
            locality,
            city,
        }

        ReplaceQuotes(data)

        updateOrderAddress(data)
            .then(() => {
                this.handleClose(true)
                window.showDialog(
                    {
                        title: strings.editAddressSuccessTitle,
                        message: strings.editAddressSuccess,
                    },
                    () => this.props.actionDone()
                )
            })
            .catch((error) => {
                this.handleClose(true)
                window.showDialog(error)
            })
    }

    renderForm = () => {
        const { errors } = this.state
        const formatReq = (string) => (
            <div>
                {string}
                <span style={{ color: 'red' }}> *</span>
            </div>
        )
        const style = {
            box: { padding: '16px 8px 32px 8px', maxWidth: 350 },
            field: { marginTop: 15, flexGrow: 1 },
        }

        return (
            <div style={style.box}>
                <TextField
                    label={formatReq(strings.editAddressStreetName)}
                    value={this.state.streetName}
                    placeholder={strings.editAddressStreetNamePlaceholder}
                    onChange={(x) =>
                        this.setState({
                            streetName: x.target.value,
                            errors: {
                                ...errors,
                                streetName: !x.target.value.trim(),
                            },
                            wasEdited: true,
                        })
                    }
                    error={errors.streetName}
                    // helperText={helperText.streetName}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    style={style.field}
                />

                <div style={{ display: 'flex' }}>
                    <TextField
                        label={formatReq(strings.editAddressStreetNumber)}
                        value={this.state.streetNumber}
                        placeholder={strings.editAddressStreetNumberPlaceholder}
                        onChange={(x) =>
                            this.setState({
                                streetNumber: x.target.value,
                                errors: {
                                    ...errors,
                                    streetNumber: !x.target.value.trim(),
                                },
                                wasEdited: true,
                            })
                        }
                        error={errors.streetNumber}
                        // helperText={helperText.streetNumber}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        style={style.field}
                        disabled={this.state.streetNumberEmpty}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                size={'small'}
                                checked={this.state.streetNumberEmpty}
                                onChange={() =>
                                    this.setState({
                                        streetNumberEmpty:
                                            !this.state.streetNumberEmpty,
                                        streetNumber: !this.state
                                            .streetNumberEmpty
                                            ? strings.editAddressStreetNumberEmpty
                                            : '',
                                        wasEdited: true,
                                    })
                                }
                            />
                        }
                        label={
                            <div style={{ fontSize: '80%', width: 80 }}>
                                {strings.editAddressStreetNumberEmpty}
                            </div>
                        }
                        style={{ margin: 0 }}
                    />
                </div>

                <TextField
                    label={strings.editAddressFloor}
                    value={this.state.floor}
                    placeholder={strings.editAddressFloorPlaceholder}
                    onChange={(x) =>
                        this.setState({
                            floor: x.target.value,
                            wasEdited: true,
                            errors: { ...errors, floor: false },
                        })
                    }
                    error={errors.floor}
                    // helperText={helperText.floor}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    style={style.field}
                />

                <TextField
                    label={strings.editAddressApartment}
                    value={this.state.apartment}
                    placeholder={strings.editAddressApartmentPlaceholder}
                    onChange={(x) =>
                        this.setState({
                            apartment: x.target.value,
                            wasEdited: true,
                            errors: { ...errors, apartment: false },
                        })
                    }
                    error={errors.apartment}
                    // helperText={helperText.apartment}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    style={style.field}
                />

                <TextField
                    label={strings.editAddressLocality}
                    value={this.state.locality}
                    placeholder={strings.editAddressLocalityPlaceholder}
                    onChange={(x) =>
                        this.setState({
                            locality: x.target.value,
                            wasEdited: true,
                            errors: { ...errors, locality: false },
                        })
                    }
                    error={errors.locality}
                    // helperText={helperText.locality}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    style={style.field}
                />

                <TextField
                    label={strings.editAddressCity}
                    value={this.state.city}
                    onChange={(x) =>
                        this.setState({
                            city: x.target.value,
                            wasEdited: true,
                            errors: { ...errors, city: false },
                        })
                    }
                    error={errors.city}
                    // helperText={helperText.city}
                    placeholder={strings.editAddressCityPlaceholder}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    style={style.field}
                />
            </div>
        )
    }

    render() {
        return (
            <div style={{ width: '100%' }}>
                <div onClick={this.handleClickOpen}>
                    {strings.editAddressButton}
                </div>
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {strings.editAddressDialogTitle}
                    </DialogTitle>
                    <DialogContent>
                        {this.state.loading ? null : this.renderForm()}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.handleClose}
                            color="primary"
                            disabled={this.state.loading}
                        >
                            {strings.close}
                        </Button>
                        <Button
                            onClick={this.confirm}
                            color="primary"
                            autoFocus
                            disabled={!this.state.wasEdited}
                        >
                            {strings.editAddressDialogSave}
                        </Button>
                    </DialogActions>
                    {this.state.loading ? <Loader /> : null}
                </Dialog>
            </div>
        )
    }
}

export default Component